<template>
    <HeaderSite :parentMenu="this.$route.name" />
    <div>
        <div class="container client">
            <div class="row my-5 justify-content-md-center">
                <div class="col-md-auto p-3 align-self-center text-center" v-for="client in clients" :key="client.id">
                    <img :src="subPathEnv+client.image"/>
                </div>
            </div>
        </div>
    </div>
   
    <FooterSite />
    
</template>

<script>
import HeaderSite from '@/components/headerSite.vue';
import FooterSite from '@/components/footerSite.vue';

export default {
    name : 'clientPage',
    components : {
        HeaderSite,
        FooterSite
    },
    data(){
        return{
            clients : [],
            subPathEnv : process.env.VUE_APP_SUBPATH+'images'
        }
    },
    mounted() {
        this.loadClient();
    },
    methods : {
        loadClient : function(){

            this.axios
            .get(process.env.VUE_APP_SUBPATH+'data-sample/client.json')
            .then(response => {
                this.clients = response.data;
            })

        }
        
    }
}
</script>

<style scoped>
.client img{
    transition: transform .5s;
}
.client img:hover{
    transform: scale(1.1); 
}

@media screen and (max-width: 1199px) {
    
}

@media screen and (max-width: 777px) {
    .client img{
        max-width: 100%;
    }
}

</style>